// extracted by mini-css-extract-plugin
export default {"container":"mTitle_container__icdMf","container_arrow":"mTitle_container_arrow__jsBfv"};